import React, { useEffect, useState } from "react";
import {
  CopyLogo,
  DownloadSampleIcon,
  Downloadopt,
  Filteropt,
  LineIcon,
  LineSymbol,
  LinesIcon,
  Refreshopt,
  RightArrow,
  Searchopt,
  copyLogo
} from "../../../../../utility/constants/assetsManager";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import CustomTable from "../../../../components/main_comps/custom_table";
import { setHeaders } from "../../../../../services/aclValidateServiceTable";
import { VanCustomerHeaders } from "../../../../../utility/TableHeaders";
import MainComponent from "../../../../components/ui_comps/MainComponent";
import FilterComponent from "../../../../components/ui_comps/FilterComponent";
import { showHideFilterModalReducer } from "../../../../../data/redux/slice/globalFiltersSlice";
import { useDispatch, useSelector } from "react-redux";
import { ApiRequestGet } from "../../../../../data/network/services/ApiRequestGet";
import { CopyToClipboard } from "react-copy-to-clipboard";
import {
  CLIENT,
  STATUS_CODE_200,
  SUCCESS,
  VAN_CUSTOMER_DOWNLOAD,
  VAN_CUSTOMER_LIST
} from "../../../../../utility/constants/valueConstants";
import { ApiRequestPost } from "../../../../../data/network/services/ApiRequestPost";
import { fetchVanCustomer } from "../../../../../services/fetchListingData";
import ResizeListner from "../../../../../utility/ResizeListner";
import moment from "moment";
import CustomModal from "../../../../components/main_comps/custom_modal";
import { CustomViewModal } from "../../../../components/main_comps/custom_modal/CustomViewModal";
import { primaryColor } from "../../../../../utility/constants/colorManager";
import CustomTabs from "../../../../components/main_comps/custom_tabs";
import DownloadReportCustomer from "./DownloadReportCustomer";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import secureStorage from "../../../../../services/secureStorage";
import {
  SS_AUTH_TOKEN,
  SS_ROLE,
  SS_USER_HASH_ID
} from "../../../../../utility/constants/secureStorageManager";
import CustomSelect from "../../../../components/main_comps/custom_select";
import { useSnackbar } from "notistack";
import {
  validateEmail,
  validatePan
} from "../../../../../utility/emailValidator";
import QRCode from "qrcode";
import { saveAs } from "file-saver";

const RadioButton = ({
  id,
  value,
  name,
  title,
  onChange,
  defaultChecked,
  style,
  disabled = false
}) => {
  return (
    <div
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <input
        disabled={disabled}
        type="radio"
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        defaultChecked={defaultChecked}
        checked={defaultChecked}
        style={{
          margin: "0px 10px"
          //background: "#3361FF"
        }}
      />
      <label htmlFor={id}>{title}</label>
    </div>
  );
};
export const ActionComponent = ({
  onClick,
  aclData,
  onServiceProviderChange,
  clientSecret,
  isClient,
  openVanModal
}) => {
  const [currentSvcProvider, setCurrentSvcProvider] = useState();
  const [options, setOptions] = useState([]);

  const serviceProviders = [
    {
      label: "Equitas Van",
      value: "van"
    },
    {
      label: "Van Upi",
      value: "van-upi"
    }
  ];

  let hasVan;
  let hasVanUpi;

  useEffect(() => {
    if (isClient) {
      hasVan = clientSecret.some(
        (obj) =>
          obj.serviceType?.toUpperCase() === "VAN" &&
          obj.serviceProviderName?.toUpperCase() === "EQUITAS"
      );

      hasVanUpi = clientSecret.some(
        (obj) =>
          obj.serviceType?.toUpperCase() === "VAN-UPI" &&
          obj.serviceProviderName?.toUpperCase() === "EQUITAS"
      );

      if (hasVan && hasVanUpi) {
        setCurrentSvcProvider({
          label: "Equitas Van",
          value: "van"
        });
        setOptions(serviceProviders);
      } else if (hasVan) {
        setCurrentSvcProvider({
          label: "Equitas Van",
          value: "van"
        });
        setOptions([
          {
            label: "Equitas Van",
            value: "van"
          }
        ]);
      } else if (hasVanUpi) {
        setCurrentSvcProvider({
          label: "Van Upi",
          value: "van-upi"
        });
        setOptions([
          {
            label: "Van Upi",
            value: "van-upi"
          }
        ]);
      }
    }
  }, [isClient, clientSecret]);

  useEffect(() => {
    if (!isClient) {
      setCurrentSvcProvider({
        label: "Equitas Van",
        value: "van"
      });
      setOptions(serviceProviders);
    }
  }, [!isClient]);
  useEffect(() => {
    onServiceProviderChange(currentSvcProvider);
  }, [currentSvcProvider]);
  const role = secureStorage.getItem(SS_ROLE);
  const isRemitterAccountVerified = clientSecret?.some(
    (obj) => obj.remitterAccountVerified
  );

  return (
    <div style={{ display: "flex" }}>
      {isClient && isRemitterAccountVerified && (
        <CustomButton
          styles={{
            backgroundColor: "#38369C",
            border: "1px solid #38369C",
            marginLeft: "10px",
            marginRight: "20px"
          }}
          title="Create VAN/VPA"
          textStyles={{ color: "white" }}
          onClick={openVanModal}
        />
      )}

      <CustomSelect
        options={options}
        isSearchable={false}
        onChange={(data) => {
          setCurrentSvcProvider(data);
        }}
        value={currentSvcProvider}
        style={{
          height: 40,
          backgroundColor: "rgba(111, 108, 255, 0.1)",
          border: "1px solid #001777",
          "&:hover": {
            border: "1px solid #001777"
          },
          borderRadius: "4px"
        }}
      />
      {aclData?.includes(VAN_CUSTOMER_DOWNLOAD) && (
        <CustomButton
          styles={{
            backgroundColor: "#38369C",
            border: "1px solid #38369C",
            marginLeft: "10px"
          }}
          title="Download Report"
          textStyles={{ color: "white" }}
          onClick={onClick}
        />
      )}
    </div>
  );
};

export const ServiceRate = ({ data, serviceProviderType }) => {
  return serviceProviderType === "van" ? (
    <div style={{ color: "rgba(122, 121, 121, 1)", lineHeight: 2 }}>
      <div style={{ color: primaryColor }}>
        {data?.first_name + " " + data?.last_name}
      </div>
      <div> {`VAN number : ${data?.van_account_number}`}</div>
      <div> {`VAN IFSC : ${data?.van_account_ifsc}`}</div>
      <div>{`Mobile Number: ${data?.mobile_number}`}</div>
      {/* <div> {`Business name : ${data?.clients?.businessName}`} </div> */}
      <div>{`RMR Account number : ${data?.remitterAcc[0].remitterAccNumber}`}</div>
      <div>{`RMR IFSC : ${data?.remitterAcc[0].remitterAccIfsc}`}</div>
      <div style={{ color: primaryColor }}>{`KYC status: ${
        data?.panVerified === true ? "PAN" : ""
      }`}</div>
      <div
        style={{ color: primaryColor }}
      >{`PAN No : ${data?.pan_number}`}</div>
      {/* <div>{`DOB : ${data?.}`}</div> */}
    </div>
  ) : (
    <div
      style={{
        color: "rgba(122, 121, 121, 1)",
        lineHeight: 2
      }}
    >
      <div style={{ color: primaryColor }}>
        {data?.first_name + " " + data?.last_name}
      </div>
      <div> {`UPI : ${data?.van_upi_id}`}</div>
      <div>{`Mobile Number: ${data?.mobile_number}`}</div>
      {data?.remitterAcc?.map((e) => (
        <div key={e?._id} style={{ height: "auto" }}>
          <div>{`RMR Account number : ${e?.remitterAccNumber}`}</div>
          <div>{`RMR IFSC : ${e?.remitterAccIfsc}`}</div>
        </div>
      ))}
    </div>
  );
};

export const CreateIntentQr = ({ closeModal, data }) => {
  const [qrValue, setQrValue] = useState("static");
  const [amount, setAmount] = useState("");
  const { enqueueSnackbar } = useSnackbar();

  const inputStyle = {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#1E2234"
  };

  const containerStyle = {
    maxWidth: "343px",
    height: "44px",
    left: "calc(50% - 343px/2)",
    top: "24px",
    background: "#FFFFFF",
    border: "1px solid #CBCACA",
    borderRadius: "6px",
    color: "#697D95",
    margin: "5px 0 20px 0",
    paddingLeft: "10px"
  };

  const generateQr = async () => {
    ApiRequestPost.qrGenerateEqUpi({
      customerVPA: data.van_upi_id,
      amount,
      upiProgramId: data.program_id
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(res.message, {
            variant: "success"
          });
          closeModal(true, res?.data?.intentString);
        } else {
          enqueueSnackbar(res.message, {
            variant: "error"
          });
          closeModal(true);
        }
      })
      .catch((err) => {
        closeModal(true);
        enqueueSnackbar(err.message, {
          variant: "error"
        });
      });
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          margin: "30px 20px 20px 0px "
        }}
      >
        <RadioButton
          //disabled={disabled}
          id="static"
          name={"static"}
          title="Static"
          value="static"
          onChange={(val) => {
            setQrValue(val.target.value);
          }}
          defaultChecked={qrValue === "static"}
        />

        <RadioButton
          //disabled={disabled}
          id="dynamic"
          name={"static"}
          title="Dynamic "
          value="dynamic"
          onChange={(val) => {
            setQrValue(val.target.value);
          }}
          defaultChecked={qrValue === "dynamic"}
          style={{
            margin: "0px 10px"
          }}
        />
      </div>
      {qrValue === "dynamic" ? (
        <div style={{ minWidth: "343px" }}>
          <label style={styles.label}>Enter Amount</label>
          <CustomInput
            value={amount}
            onChange={(data) => setAmount(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Enter Amount"
            validator="number"
            type="input"
            inputStyles={{
              ...containerStyle
            }}
          />
        </div>
      ) : (
        <></>
      )}
      <div style={{ display: "flex", marginLeft: "130px", marginTop: "40px" }}>
        <CustomButton
          title="Cancel"
          styles={{ background: "#FDFDFD", margin: "0 15px 0 0" }}
          textStyles={{
            color: "#1E2234",
            fontWeight: "500",
            fontSize: "16px"
          }}
          onClick={() => {
            closeModal(true);
          }}
        />

        <CustomButton
          title="Create "
          styles={{ background: "#38369C", margin: "0 15px 0 0" }}
          textStyles={{
            color: "#FFFFFF",
            fontWeight: "500",
            fontSize: "16px"
          }}
          onClick={() => {
            generateQr();
          }}
        />
      </div>
    </>
  );
};

export const CopyIntentQr = ({ link, closeModal }) => {
  const truncatedLink = link.slice(0, 20);
  const [copyText, setCopyText] = useState("Copy link");
  const [qrCodeUrl, setQrCodeUrl] = useState("");

  useEffect(() => {
    QRCode.toDataURL(link).then((url) => {
      setQrCodeUrl(url);
    });
  }, [link]);
  const handleCopy = () => {
    setCopyText("Copied");
  };
  const downloadQr = () => {
    saveAs(qrCodeUrl, "upi-qr-code.png");
  };

  return (
    <div>
      <p style={{ margin: "20px 0", color: "#7181A1", fontWeight: 500 }}>
        Link
      </p>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <p style={{ color: "#3361FF", fontSize: "16px", fontWeight: 400 }}>
          {truncatedLink}
        </p>
        <CopyToClipboard text={link} onCopy={handleCopy}>
          <div
            style={{
              height: "34px",
              width: "124px",
              background: "#3361FF",
              color: "#FFFFFF",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "6px",
              padding: "10px",
              cursor: "pointer"
            }}
          >
            <p style={{ marginRight: "10px" }}>{copyText}</p>
            <CopyLogo width={20} height={20} />
          </div>
        </CopyToClipboard>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "40px",
          gap: "10px"
        }}
      >
        <CustomButton
          styles={{
            background: "#3361FF",
            border: "1px solid #38369C"
          }}
          title="OK"
          textStyles={{ color: "white" }}
          onClick={() => {
            closeModal(true);
          }}
        />
        <CustomButton
          styles={{
            background: "#3361FF",
            border: "1px solid #38369C"
          }}
          title="download QR"
          textStyles={{ color: "white" }}
          onClick={() => {
            downloadQr();
          }}
        />
      </div>
    </div>
  );
};

const VanTransactionIndex = ({ onChange }) => {
  const role = secureStorage.getItem(SS_ROLE);
  const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
  const { width, height } = ResizeListner();
  const dispatch = useDispatch();
  const vanList = useSelector(
    (state) => state.listingSlice?.vanCustomerDetails
  );

  const [viewMoreData, setViewMoreData] = useState({});

  useEffect(() => {
    setViewMoreData(vanList || []);
  }, []);

  const filters = useSelector((state) => state.globalFiltersSlice);
  const clientSecret = useSelector((state) => state.listingSlice.clientDetails);

  // const [page, setPage] = useState(1);

  const [viewMoreModal, setViewMoreModal] = useState(false);
  const [dataForModal, setDataForModal] = useState({});
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [clientDetails, setClientDetials] = useState({});
  const aclData = useSelector((state) => state.aclSlice.aclList);
  const [serviceProviderType, setServiceProviderType] = useState("");
  const [openVanModal, setOpenVanModal] = useState(false);
  const [currentValue, setCurrentValue] = useState("van");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [pan, setPan] = useState("");
  const [email, setEmail] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [upiProgramId, setUpiProgramId] = useState("");
  const [qrCreateModal, setQrCreateModal] = useState(false);
  const [copyQrModal, setCopyQrModal] = useState(false);
  const [qrLink, setQrLink] = useState("");
  const [vanProgramId, setVanProgramId] = useState("");
  const [token, setToken] = useState("");
  const [van, setVan] = useState([]);
  const [vanUpi, setVanUpi] = useState([]);

  // const inputStyle = {
  //   backgroundColor: "#F3F3F3",
  //   fontWeight: "400",
  //   fontSize: "14px",
  //   color: "#6C6B6B"
  // };
  // const containerStyle = {
  //   height: "20px",
  //   width: "300px",
  //   border: "none"
  // };

  const inputStyle = {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#1E2234"
  };

  const containerStyle = {
    maxWidth: "343px",
    height: "44px",
    left: "calc(50% - 343px/2)",
    top: "24px",
    background: "#FFFFFF",
    border: "1px solid #CBCACA",
    borderRadius: "6px",
    color: "#697D95",
    margin: "5px 0 20px 0",
    paddingLeft: "10px"
  };

  const getClientProgram = () => {
    let van = clientSecret.filter(
      (obj) =>
        obj.serviceType?.toUpperCase() === "VAN" &&
        obj.serviceProviderName?.toUpperCase() === "EQUITAS"
    );

    let vanUpi = clientSecret.filter(
      (obj) =>
        obj.serviceType?.toUpperCase() === "VAN-UPI" &&
        obj.serviceProviderName?.toUpperCase() === "EQUITAS"
    );

    if (van.length > 0) {
      setClientDetials(van[0]);
      setVanProgramId(van[0].program);
    }
    if (vanUpi.length > 0) {
      setClientDetials(vanUpi[0]);
      setUpiProgramId(vanUpi[0].program);
    }
  };

  const getAllClientSecretDetails = () => {
    const van = clientSecret.filter(
      (obj) =>
        obj.serviceType?.toUpperCase() === "VAN" &&
        obj.serviceProviderName?.toUpperCase() === "EQUITAS" &&
        obj.remitterAccountVerified === true
    );

    const vanUpi = clientSecret.filter(
      (obj) =>
        obj.serviceType?.toUpperCase() === "VAN-UPI" &&
        obj.serviceProviderName?.toUpperCase() === "EQUITAS" &&
        obj.remitterAccountVerified === true
    );

    setVan(van);
    setVanUpi(vanUpi);

    if (van.length > 0 && vanUpi.length > 0) {
      setCurrentValue("van");
    } else if (van.length > 0) {
      setCurrentValue("van");
    } else if (vanUpi.length > 0) {
      setCurrentValue("vpa");
    }
  };
  function filterData(data) {
    return data?.map((test) => {
      if (Array.isArray(test?.remitterAcc) && test?.remitterAcc?.length > 0) {
        const remitterAcc = test.remitterAcc[0];

        return { ...test, ...remitterAcc };
      }
      return test;
    });
  }

  useEffect(() => {
    getClientProgram();
    getAllClientSecretDetails();
  }, []);

  const fetchCustomerData = () => {
    if (serviceProviderType) {
      dispatch(
        fetchVanCustomer({
          dateRange: "",
          page: 0,
          size: 10,
          keyWord: "",
          name: "",
          van: "",
          // business: "",
          status: "",
          clientHashId: role === CLIENT ? ss_id : "",
          txnId: "",
          transferType: "",
          programId: role === CLIENT ? clientDetails?.program : "",
          serviceType: serviceProviderType
        })
      );
    }
  };

  useEffect(() => {
    fetchCustomerData();
  }, [serviceProviderType]);

  const setHeaders = (data, role, serviceProviderType, acl) => {
    let arr = [];

    let updatedData = data.filter(
      (e) =>
        e.serviceProviderType === serviceProviderType ||
        e.serviceProviderType === "all"
    );

    updatedData.map((val) => {
      if (
        serviceProviderType?.toUpperCase() === "VAN-UPI" &&
        val.key === "intent" &&
        vanUpi.length === 0
      ) {
        // Skip adding "Intent Create" header if vanUpi length is 0
        return;
      }

      if (val?.roles || val?.acl) {
        if (val?.roles?.includes(role) || acl?.includes(val?.acl)) {
          arr.push({
            title: val?.title,
            key: val?.key
          });
        }
      } else {
        arr.push({
          title: val?.title,
          key: val?.key
        });
      }
    });

    return arr;
  };

  const resetForm = () => {
    setFirstName("");
    setMiddleName("");
    setLastName("");
    setMobileNumber("");
    setEmail("");
    setPan("");
  };

  const createCustomerVpa = async () => {
    ApiRequestPost.createVpaCustomer({
      firstName,
      lastName,
      mobileNumber,
      pan,
      email,
      middleName,
      upiProgramId
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(res.message, {
            variant: "success"
          });
          setOpenVanModal(false);
          resetForm();
          fetchCustomerData();
        } else {
          enqueueSnackbar(res.message, {
            variant: "error"
          });
          setOpenVanModal(false);
          resetForm();
        }
      })
      .catch((err) => {
        setOpenVanModal(false);
        resetForm();
        enqueueSnackbar(err.message, {
          variant: "error"
        });
      });
  };
  const createCustomerVan = async (token) => {
    ApiRequestPost.createVanCustomer({
      firstName,
      lastName,
      mobileNumber,
      pan,
      email,
      middleName,
      token
    })
      .then((res) => {
        if (res.status === SUCCESS) {
          enqueueSnackbar(res.message, {
            variant: "success"
          });
          setOpenVanModal(false);
          resetForm();
          fetchCustomerData();
        } else {
          enqueueSnackbar(res.message, {
            variant: "error"
          });
          setOpenVanModal(false);
          resetForm();
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error"
        });
        setOpenVanModal(false);
        resetForm();
      });
  };

  const generateTokenVan = async () => {
    ApiRequestPost.generateAuthenticatedTokenForVan({ programId: vanProgramId })
      .then((res) => {
        if (res.status === SUCCESS) {
          createCustomerVan(res.data);
        } else {
          enqueueSnackbar(res.message, {
            variant: "error"
          });
          setOpenVanModal(false);
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error"
        });
        setOpenVanModal(false);
      });
  };

  return (
    <div
      style={{
        marginLeft: "20px",
        overflow: "auto",
        boxSizing: "border-box",
        width: "100%"
      }}
    >
      <MainComponent
        currentServiceType={serviceProviderType}
        headerTitle="Customer"
        notificationRequired={false}
        filterRequired={true}
        onClickFilter={() => {
          dispatch(
            showHideFilterModalReducer({
              showFilterModal: true,
              filters: ["dateRange", "clientName", "vanNumber", "Vanstatus"]
            })
          );
        }}
        onClickFilterCall={(data) => {
          // setPage(0);
          dispatch(
            fetchVanCustomer({
              page: 0,
              size: 10,
              totalRecords: "",
              dateRange:
                data?.fromDate && data?.toDate
                  ? moment(data?.fromDate).format("DD/MM/YYYY") +
                    "-" +
                    moment(data?.toDate).format("DD/MM/YYYY")
                  : "",
              business: "",
              keyWord: "",
              van: data?.van ?? "",
              name: "",
              status: data?.status?.value ?? "",
              clientHashId:
                role === CLIENT ? ss_id : data?.clientId?.value ?? "",
              txnId: "",
              programId: role === CLIENT ? clientDetails?.program : "",
              serviceType: serviceProviderType
            })
          );
        }}
      />
      <CustomTabs
        actionComponent={
          <ActionComponent
            onClick={() => setShowDownloadModal(true)}
            aclData={aclData}
            onServiceProviderChange={(data) => {
              setServiceProviderType(data?.value);
            }}
            clientSecret={clientSecret}
            isClient={role === CLIENT}
            openVanModal={() => setOpenVanModal(true)}
          />
        }
      />
      {showDownloadModal && (
        <CustomModal
          headerTitle="Download Report"
          open={showDownloadModal}
          onClose={() => {
            setShowDownloadModal(false);
          }}
          containerStyle={styles.modalContainerStyle}
        >
          <DownloadReportCustomer
            programId={clientDetails?.program}
            serviceProviderType={serviceProviderType}
          />
        </CustomModal>
      )}

      <div style={styles.maindiv}>
        <div style={styles.tablestyle}>
          {aclData?.includes(VAN_CUSTOMER_LIST) && (
            <>
              <CustomTable
                data={vanList?.customers}
                currentPage={vanList?.currentPageNo - 1}
                headers={setHeaders(
                  VanCustomerHeaders,
                  role,
                  serviceProviderType
                )}
                totalElements={vanList?.totalRecords}
                totalPages={vanList?.totalPages}
                handlePaginate={(page) => {
                  if (serviceProviderType) {
                    dispatch(
                      fetchVanCustomer({
                        page: page + 1,
                        size: 10,
                        dateRange:
                          filters?.fromDate && filters?.toDate
                            ? moment(filters?.fromDate).format("DD/MM/YYYY") +
                              "-" +
                              moment(filters?.toDate).format("DD/MM/YYYY")
                            : "",
                        business: "",
                        keyWord: "",
                        van: filters?.van ?? "",
                        name: "",
                        status: filters?.status?.value ?? "",
                        clientHashId:
                          role === CLIENT
                            ? ss_id
                            : filters?.clientId?.value ?? "",
                        txnId: "",
                        programId:
                          role === CLIENT ? clientDetails?.program : "",
                        serviceType: serviceProviderType
                      })
                    );
                  }
                }}
                onViewMore={(row) => {
                  setViewMoreModal(true);
                  setViewMoreData(row);
                }}
                onQrCreate={(create, row) => {
                  if (create) {
                    setQrCreateModal(true);
                  }
                  setViewMoreData(row);
                }}
              />
            </>
          )}

          {viewMoreModal && (
            <CustomModal
              containerStyle={{ width: 500, height: "auto" }}
              open={viewMoreModal}
              onClose={() => {
                setViewMoreModal(false);
                setDataForModal({});
              }}
              isHeaderRequired={true}
              headerTitle="Customer Details"
            >
              <ServiceRate
                data={viewMoreData}
                serviceProviderType={serviceProviderType}
              />
            </CustomModal>
          )}
        </div>
      </div>

      {openVanModal && (
        <CustomModal
          headerTitle="Create VAN/VPA"
          open={openVanModal}
          onClose={() => {
            setOpenVanModal(false);
          }}
          containerStyle={styles.modalContainerStyle}
        >
          <div style={{ marginLeft: "0px" }}>
            <div
              style={{
                display: "flex",
                margin: "20px"
              }}
            >
              {van.length > 0 && (
                <RadioButton
                  id="van"
                  name="van"
                  title="VAN"
                  value="van"
                  onChange={(val) => {
                    setCurrentValue(val.target.value);
                  }}
                  defaultChecked={currentValue === "van"}
                />
              )}
              {vanUpi.length > 0 && (
                <RadioButton
                  id="vpa"
                  name="van"
                  title="VPA"
                  value="vpa"
                  onChange={(val) => {
                    setCurrentValue(val.target.value);
                  }}
                  defaultChecked={currentValue === "vpa"}
                  style={{
                    margin: "0px 10px"
                  }}
                />
              )}
            </div>
            <div style={{ marginLeft: "10px" }}>
              <div style={{ minWidth: "343px" }}>
                <label style={styles.label}>First Name</label>
                <CustomInput
                  value={firstName}
                  onChange={(data) => setFirstName(data)}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="Enter First Name"
                  validator="name"
                  type="input"
                  inputStyles={{
                    ...containerStyle
                  }}
                />
              </div>
              <div style={{ minWidth: "343px" }}>
                <label style={styles.label}>Middle Name</label>
                <CustomInput
                  value={middleName}
                  onChange={(data) => setMiddleName(data)}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="Enter Middle Name"
                  validator="name"
                  type="input"
                  inputStyles={{
                    ...containerStyle
                  }}
                />
              </div>
              <div style={{ minWidth: "343px" }}>
                <label style={styles.label}>Last Name</label>
                <CustomInput
                  value={lastName}
                  onChange={(data) => setLastName(data)}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="Enter Last Name"
                  validator="name"
                  type="input"
                  inputStyles={{
                    ...containerStyle
                  }}
                />
              </div>

              <div style={{ minWidth: "343px" }}>
                <label style={styles.label}>Mobile Number</label>
                <CustomInput
                  value={mobileNumber}
                  onChange={(data) => setMobileNumber(data)}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="Enter Mobile Number"
                  validator="mobile"
                  type="input"
                  inputStyles={{
                    ...containerStyle
                  }}
                />
              </div>
              <div style={{ minWidth: "343px" }}>
                <label style={styles.label}>Email</label>
                <CustomInput
                  value={email}
                  onChange={(data) => setEmail(data)}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="Email"
                  validator="email"
                  type="input"
                  inputStyles={{
                    ...containerStyle
                  }}
                />
              </div>
              <div style={{ minWidth: "343px" }}>
                <label style={styles.label}>PAN Number</label>
                <CustomInput
                  value={pan}
                  onChange={(data) => {
                    setPan(data);
                  }}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="Enter PAN"
                  validator="pan"
                  type="input"
                  inputStyles={{
                    ...containerStyle
                  }}
                />
              </div>
            </div>
            <div style={{ display: "flex", marginLeft: "100px" }}>
              <CustomButton
                title="Cancel"
                styles={{ background: "#FDFDFD", margin: "0 15px 0 0" }}
                textStyles={{
                  color: "#1E2234",
                  fontWeight: "500",
                  fontSize: "16px"
                }}
                onClick={() => {
                  setOpenVanModal(false);
                }}
              />

              {currentValue === "vpa" ? (
                <CustomButton
                  title="Create VPA"
                  styles={{ background: "#38369C", margin: "0 15px 0 0" }}
                  textStyles={{
                    color: "#FFFFFF",
                    fontWeight: "500",
                    fontSize: "16px"
                  }}
                  onClick={() => {
                    if (firstName === "") {
                      enqueueSnackbar("Please enter first name", {
                        variant: "error"
                      });
                      return;
                    }
                    if (lastName === "") {
                      enqueueSnackbar("Please enter last name", {
                        variant: "error"
                      });
                      return;
                    }
                    if (mobileNumber.length < 10) {
                      enqueueSnackbar("Please enter a valid mobile number", {
                        variant: "error"
                      });
                      return;
                    }
                    if (!validateEmail(email)) {
                      enqueueSnackbar("Please enter a valid email", {
                        variant: "error"
                      });
                      return;
                    }
                    if (!validatePan(pan)) {
                      enqueueSnackbar("Please enter a valid Pan", {
                        variant: "error"
                      });
                      return;
                    }

                    createCustomerVpa();
                  }}
                />
              ) : (
                <CustomButton
                  title="Create VAN"
                  styles={{ background: "#38369C", margin: "0 15px 0 0" }}
                  textStyles={{
                    color: "#FFFFFF",
                    fontWeight: "500",
                    fontSize: "16px"
                  }}
                  onClick={() => {
                    if (firstName === "") {
                      enqueueSnackbar("Please enter first name", {
                        variant: "error"
                      });
                      return;
                    }
                    if (lastName === "") {
                      enqueueSnackbar("Please enter last name", {
                        variant: "error"
                      });
                      return;
                    }
                    if (mobileNumber.length < 10) {
                      enqueueSnackbar("Please enter a valid mobile number", {
                        variant: "error"
                      });
                      return;
                    }
                    if (!validateEmail(email)) {
                      enqueueSnackbar("Please enter a valid email", {
                        variant: "error"
                      });
                      return;
                    }
                    if (!validatePan(pan)) {
                      enqueueSnackbar("Please enter a valid Pan", {
                        variant: "error"
                      });
                      return;
                    }

                    generateTokenVan();
                  }}
                />
              )}
            </div>
          </div>
        </CustomModal>
      )}
      {qrCreateModal && (
        <CustomModal
          containerStyle={{ width: 400, height: "auto" }}
          open={qrCreateModal}
          onClose={() => {
            setQrCreateModal(false);
          }}
          isHeaderRequired={true}
          headerTitle="Create Intent QR"
        >
          <CreateIntentQr
            closeModal={(modal, link) => {
              if (modal && link) {
                setQrLink(link);
                setQrCreateModal(false);
                setCopyQrModal(true);
              } else {
                setQrCreateModal(false);
              }
            }}
            data={viewMoreData}
          />
        </CustomModal>
      )}

      {copyQrModal && (
        <CustomModal
          containerStyle={{ width: "400px", height: "auto" }}
          open={copyQrModal}
          onClose={() => {
            setCopyQrModal(false);
          }}
          isHeaderRequired={true}
          headerTitle="Create Intent "
        >
          <CopyIntentQr
            link={qrLink}
            closeModal={(modal) => {
              if (modal) {
                setCopyQrModal(false);
              }
            }}
          />
        </CustomModal>
      )}
    </div>
  );
};

const styles = {
  upperdiv: {
    height: "52px",
    background: "#F7F9FB",
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    paddingRight: "20px",
    marginBottom: "20px"
  },
  image: {
    height: "20px",
    width: "20px",
    margin: "10px"
  },
  image2: {
    height: "20px",
    width: "20px"
  },
  searchdiv: {
    width: "360px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    background: "#FFFFFF",
    border: "1px solid rgba(105, 105, 105, 0.3)",
    borderRadius: "6px"
  },
  maindiv: {
    backgroundColor: "#FFFFFF",
    paddingTop: "20px",
    paddingLeft: "20px",
    width: "100%"
  },
  tablestyle: {
    overflow: "hidden",

    boxSizing: "border-box"
  },
  modalContainerStyle: {
    minWidth: 350,
    maxWidth: 400,
    height: "auto",
    maxHeight: 800
  }
};
export default VanTransactionIndex;
